// A screenshot of the restaurant's shop in the platform agent's panel (contracts §5 card shop_screenshot, §9).
export default {
  title: {
    phone: 'Il tuo shop su un telefono',
    desktop: 'Il tuo shop su un computer',
  },
  loading: 'Caricamento dello screenshot',
  failed: 'Impossibile caricare lo screenshot.',
};
